<div class="flex max-w-[500px] select-none flex-col gap-4 rounded-xl bg-neutral-0 p-8">
  <div class="flex flex-row justify-between">
    <svg width="69" height="64" viewBox="0 0 69 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2327_4431)">
        <path d="M23.7187 46.36L19.4062 42.358L16.3638 45.178L23.7187 52L36.6562 40L33.6159 37.18L23.7187 46.36Z" fill="#585FFF" />
        <path
          d="M60.375 60H51.75V56H60.375V32H51.75V16C51.7474 13.879 50.8379 11.8456 49.221 10.3458C47.604 8.846 45.4117 8.00238 43.125 8V4C46.5551 4.00355 49.8435 5.26897 52.269 7.51864C54.6944 9.7683 56.0587 12.8185 56.0625 16V28H60.375C61.5184 28.0011 62.6146 28.4229 63.4231 29.1728C64.2316 29.9227 64.6863 30.9395 64.6875 32V56C64.6863 57.0605 64.2316 58.0773 63.4231 58.8272C62.6146 59.5771 61.5184 59.9989 60.375 60Z"
          fill="#3E43B3" />
        <path
          d="M43.125 28H38.8125V16C38.8125 12.8174 37.4494 9.76515 35.0232 7.51472C32.5969 5.26428 29.3062 4 25.875 4C22.4438 4 19.1531 5.26428 16.7268 7.51472C14.3006 9.76515 12.9375 12.8174 12.9375 16V28H8.625C7.48125 28 6.38435 28.4214 5.5756 29.1716C4.76685 29.9217 4.3125 30.9391 4.3125 32V56C4.3125 57.0609 4.76685 58.0783 5.5756 58.8284C6.38435 59.5786 7.48125 60 8.625 60H43.125C44.2687 60 45.3656 59.5786 46.1744 58.8284C46.9831 58.0783 47.4375 57.0609 47.4375 56V32C47.4375 30.9391 46.9831 29.9217 46.1744 29.1716C45.3656 28.4214 44.2687 28 43.125 28ZM17.25 16C17.25 13.8783 18.1587 11.8434 19.7762 10.3431C21.3937 8.84285 23.5875 8 25.875 8C28.1625 8 30.3563 8.84285 31.9738 10.3431C33.5913 11.8434 34.5 13.8783 34.5 16V28H17.25V16ZM43.125 56H8.625V32H43.125V56Z"
          fill="#585FFF" />
      </g>
      <defs>
        <clipPath id="clip0_2327_4431">
          <rect width="69" height="64" fill="white" />
        </clipPath>
      </defs>
    </svg>

    <button class="flex size-8 items-center justify-center rounded-full border border-neutral-8 hover:opacity-60" (click)="close()">
      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M17 1.4875L15.5125 0L8.5 7.0125L1.4875 0L0 1.4875L7.0125 8.5L0 15.5125L1.4875 17L8.5 9.9875L15.5125 17L17 15.5125L9.9875 8.5L17 1.4875Z"
          fill="#1D1D1D" />
      </svg>
    </button>
  </div>

  <span class="w-full pt-4 font-heading text-xl">{{'rememberMe.explaination.header' | translate}}</span>
  <span class="whitespace-pre-wrap text-neutral-60">{{'rememberMe.explaination' | translate}}</span>

  <div class="flex w-full justify-end pt-4" (click)="close()">
    <pay-button-primary class="max-w-fit">{{'rememberMe.explaination.confirm' | translate}}</pay-button-primary>
  </div>
</div>
